import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import { AlertRule } from './types';

export const isCreateRuleFormOpenAtom = atomWithReset(false);

export const editingRuleAtom = atomWithReset<AlertRule | null>(null);

// The rule whose change-log modal is open (null = closed).
export const historyRuleAtom = atomWithReset<AlertRule | null>(null);

// True whenever the editor pane (create or edit) should be shown.
export const ruleFormOpenAtom = atom(
  (get) => get(isCreateRuleFormOpenAtom) || get(editingRuleAtom) !== null,
);
